module.exports = __webpack_public_path__ + "static/media/Dual_4453.86c8101e.jpg";